<!-- eslint-disable max-len -->
<!-- eslint-disable max-lines -->
<template>
    <div class="collect-list">
        <h1 class="collect-list__title">
            个人信息收集清单-启蒙好课
        </h1>

        <div class="collect-list__lead">
            <p class="collect-list__para">
                为了确保您在使用高途启蒙好课时的安全性与高效性，我们特别制定了本《个人信息收集清单》。
            </p>
            <p class="collect-list__para">
                本清单详细说明了在不同功能场景下，我们如何收集、使用和保护您的个人信息。
            </p>
            <p class="collect-list__para">
                我们承诺严格遵守国家法律法规，并按照隐私保护最佳实践确保您的个人信息安全。基于「最小必要」原则，我们仅收集实现功能所必需的信息。
            </p>
        </div>

        <h2 class="collect-list__subtitle">
            信息收集与使用明细表
        </h2>

        <div class="collect-list__table-wrap">
            <table class="collect-list__table">
                <thead>
                    <tr>
                        <th scope="col">
                            业务场景
                        </th>
                        <th scope="col">
                            可能需要收集的个人信息范围
                        </th>
                        <th scope="col">
                            使用目的或对应功能
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(row, index) in tableRows"
                        :key="index"
                    >
                        <td>{{row.scenario}}</td>
                        <td>{{row.scope}}</td>
                        <td>{{row.purpose}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <h2 class="collect-list__subtitle">
            其他说明
        </h2>

        <div class="collect-list__trail">
            <p class="collect-list__para">
                请您理解，高途启蒙好课提供的功能和服务会随着软件版本的更新和功能的不断发展而发生变化，因此，上述个人信息的收集范围可能会适时调整。<!--
                -->我们将持续遵循法律法规，并在有重大变更时及时通过页面提示等方式及时通知你。如果你对本《个人信息收集清单》有任何疑问或建议，你可以通过
                <router-link class="collect-list__link" to="/policy">
                    《个人信息保护政策》
                </router-link>
                中的联系方式与我们联系。
            </p>
        </div>
    </div>
</template>

<script>

/* 表格数据逐字对应源文档《个人信息收集清单-启蒙好课》信息收集与使用明细表 */
const TABLE_ROWS = [
    {
        scenario: '账号注册/登录',
        scope: '手机号码、短信验证码',
        purpose: '用于为您提供账号注册、登录服务，验证身份安全。',
    },
    {
        scenario: '完善个人资料',
        scope: '昵称、头像、性别、生日、年级',
        purpose: '用于在应用内展示个人资料，并根据年龄/年级提供更精准的学习内容。',
    },
    {
        scenario: '核心课程学习',
        scope: '学习进度、作答记录、错题记录',
        purpose: '用于记录您的学习轨迹，生成学习报告，帮助您回顾和巩固知识。',
    },
    {
        scenario: '语音互动与评测',
        scope: '麦克风权限、语音数据',
        purpose: '用于支持跟读、语音纠错及口语评测功能。',
    },
    {
        scenario: '作品录制、上传与展示',
        scope: '摄像头权限、相册权限、存储权限、图片/视频数据',
        purpose: '用于录制学习作品、上传作品至社区、保存作品到本地以及更换个人头像。',
    },
    {
        scenario: '购买课程与订单管理',
        scope: '订单信息、支付状态、交易流水号',
        purpose: '用于确认订单、处理支付结果、提供售后服务及开具发票。',
    },
    {
        scenario: '消息通知服务',
        scope: '设备标识符（如 IMEI、Android ID）、通知权限',
        purpose: '用于向您推送课程提醒、上课通知、学习周报及重要的活动资讯。',
    },
    {
        scenario: '系统安全与风险控制',
        scope: '设备型号、操作系统版本、IP 地址、MAC 地址、设备唯一标识符',
        purpose: '用于保障软件安全运行，识别异常账号，进行反作弊及防欺诈分析。',
    },
];


export default {
    name: 'PolicyCollectList',
    components: {
    },
    data() {
        return {
            tableRows: TABLE_ROWS,
        };
    },
    mounted() {
        document.title = '个人信息收集清单';
    },
};
</script>

<style scoped>
/*
 * 与 policysummary / policythirdshare 一致：正文用 px，避免全站 rem 在横屏过大。
 */
.collect-list {
    box-sizing: border-box;
    max-width: 960px;
    margin: 0 auto;
    padding: 12px 10px 24px;
    font-size: 13px;
    line-height: 1.5;
    color: #333;
    text-align: left;
    -webkit-font-smoothing: antialiased;
}

.collect-list__title {
    margin: 0 0 12px;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    line-height: 1.35;
    color: #1a1a1a;
}

.collect-list__lead {
    margin-bottom: 12px;
}

.collect-list__subtitle {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.4;
}

.collect-list__trail {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eee;
}

.collect-list__para {
    margin: 0 0 8px;
    text-indent: 2em;
}

.collect-list__para:last-child {
    margin-bottom: 0;
}

.collect-list__link {
    color: #3370ff;
    text-decoration: none;
    word-break: break-all;
}

.collect-list__link:hover {
    text-decoration: underline;
}

@media (orientation: landscape) and (max-height: 520px) {
    .collect-list {
        padding: 8px 8px 14px;
        font-size: 12px;
    }

    .collect-list__title {
        margin-bottom: 8px;
        font-size: 16px;
    }
}

.collect-list__table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin: 0 -2px;
}

.collect-list__table {
    width: 100%;
    min-width: 520px;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 12px;
    line-height: 1.45;
    background: #fff;
}

.collect-list__table th,
.collect-list__table td {
    padding: 8px 6px;
    border: 1px solid #e0e0e0;
    vertical-align: top;
    word-break: break-word;
}

.collect-list__table th {
    font-weight: 700;
    color: #1a1a1a;
    background: #f7f8fa;
    text-align: center;
}

.collect-list__table td:first-child {
    width: 18%;
    font-weight: 600;
    color: #333;
}

.collect-list__table td:nth-child(2) {
    width: 38%;
}

.collect-list__table td:nth-child(3) {
    width: 44%;
}
</style>
